const initialState = {
  puestos: [],
  indicadores: [], // Aquí se guardarán los indicadores
  loading: false,
  error: null,
};

export default function evaluacionDesempeño(state = initialState, action) {
  switch (action.type) {
    case "LOADING_PUESTOS":
      return { ...state, loading: action.payload };
    case "SUCCESS_PUESTOS":
      return { ...state, puestos: action.payload, loading: false, error: null };
    case "ERROR_PUESTOS":
      return { ...state, error: action.payload, loading: false };
    case "LOADING_INDICADORES":
      return { ...state, loading: action.payload };
    case "SUCCESS_INDICADORES":
      return {
        ...state,
        indicadores: action.payload, // Guardar indicadores aquí
        loading: false,
        error: null,
      };
    case "ERROR_INDICADORES":
      return { ...state, error: action.payload, loading: false };
    case "LOADING_INDICADOR":
      return { ...state, loading: action.payload };
    case "SUCCESS_CREAR_INDICADOR":
      return {
        ...state,
        indicadores: [...state.indicadores, action.payload], // Agregar nuevo indicador
        loading: false,
        error: null,
      };
    case "ERROR_CREAR_INDICADOR":
      return { ...state, error: action.payload, loading: false };
    case "SUCCESS_ACTUALIZAR_INDICADOR":
      return {
        ...state,
        indicadores: state.indicadores.map((indicador) =>
          indicador.id === action.payload.id ? action.payload : indicador
        ), // Actualizar indicador existente
        loading: false,
        error: null,
      };
    case "ERROR_ACTUALIZAR_INDICADOR":
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
}
